module.exports = __webpack_public_path__ + "static/media/c2.a97bcdaf.png";